import { render, staticRenderFns } from "./EMAppTile.vue?vue&type=template&id=08f87006&scoped=true&"
import script from "./EMAppTile.vue?vue&type=script&lang=js&"
export * from "./EMAppTile.vue?vue&type=script&lang=js&"
import style0 from "./EMAppTile.vue?vue&type=style&index=0&id=08f87006&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f87006",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBadge,VCard})
